import React from 'react'
import { CompanyHeader_v2 } from '../../InvoiceDetails/components/CompanyHeader'
import { Divider } from 'react-native-paper'
import { OtherInvoiceInfo_v2 } from '../../InvoiceDetails/components/OtherInvoiceInfo'

interface InvoicePanelProps {
  invoice: {
    company: {
      name: string
      phone: string
    }
    total_amount: number
    type: string
    invoice_number: string
    invoice_due_date: string
  }
}
export const InvoicePanelMobile: React.FC<InvoicePanelProps> = ({
  invoice,
}) => {
  return (
    <>
      <CompanyHeader_v2
        name={invoice.company?.name || ''}
        phone={invoice.company?.phone || ''}
        totalAmount={Number(invoice.total_amount)}
        style={{
          paddingVertical: 20,
          flexDirection: 'row',
        }}
      />
      <Divider testID={'divider'} />
      <OtherInvoiceInfo_v2
        type={invoice.type}
        invoice_number={invoice.invoice_number}
        invoice_due_date={invoice.invoice_due_date}
      />
    </>
  )
}
